
import clsx from "clsx";
import { twMerge } from "tailwind-merge";



export function formatDate(dateString) {
  if (!dateString) return ""; // Return empty string if date is not provided
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0"); // Ensure 2-digit day format
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear().toString().slice(2); // Get last two digits of the year
  return `${day}/${month}/${year}`;
}


export function merge(...args) {
  return twMerge(clsx(args));
}

export const getTextFromHTML = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

export const isKeyboardInput = (
  event
) => {
  if ("pointerId" in event && "pointerType" in event) {
    return event.pointerId === -1 && event.pointerType === "";
  }

  return event?.detail === 0;
};